export default __webpack_public_path__ + "static/media/delivery-proof.bc7e7dd7.gif";